export const ViewIdToScroll = 'notification-panel';